import React from 'react'

import HoverTooltip from '../../../../components/HoverTooltip'
import RegistryPeriodSelect from './RegistryPeriodSelect'
import { ContractCountAndSum } from '../types'

type Props = {
    theme: string
    yearPeriod: number | null
    onYearPeriodChange: (value: number | null) => void
    contractCountAndSum: ContractCountAndSum | null
    loadingCountSum?: boolean
}

const ContractHeader: React.FC<Props> = ({
    theme,
    yearPeriod,
    onYearPeriodChange,
    contractCountAndSum,
    loadingCountSum = false,
}) => {
    const fmt = (n: number | undefined) =>
        typeof n === 'number' ? n.toLocaleString('ru-RU') : 'Нет данных'

    return (
        <div className=" h-24 mx-6 flex flex-row gap-x-5">
            <div className="w-44 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Период реестра
                </div>
                <RegistryPeriodSelect
                    startYear={new Date().getFullYear()}
                    endYear={2018}
                    value={
                        yearPeriod === null
                            ? 'all'
                            : (String(yearPeriod) as `${number}`)
                    }
                    onChange={(v) =>
                        onYearPeriodChange(v === 'all' ? null : Number(v))
                    }
                />
            </div>
            <div className="flex flex-col w-64 my-auto gap-2 content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B] pr-5">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                    <p>Договоры на исполнении</p>
                </div>
                <div className="flex flex-row w-fit my-auto content-center">
                    <div className="flex flex-col w-fit my-auto content-center pr-5">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Количество
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_count_perfgb)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col w-fit my-auto content-center">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Сумма договоров (руб.)
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_sum_perfgb)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col w-64 my-auto gap-2 content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B] pr-5">
                <div className="text-xs text-[#C15C5C] dark:text-[#C15C5C] ">
                    <p>Просроченные договоры</p>
                </div>
                <div className="flex flex-row w-fit my-auto content-center">
                    <div className="flex flex-col w-fit my-auto content-center pr-5">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Количество
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_count_perfbad)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col w-fit my-auto content-center">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Сумма договоров (руб.)
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_sum_perfbad)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col w-64 my-auto gap-2 content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B] pr-5">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Завершенные договоры
                </div>
                <div className="flex flex-row w-fit my-auto content-center">
                    <div className="flex flex-col w-fit my-auto content-center pr-5">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Количество
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_count_close)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col w-fit my-auto content-center">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Сумма договоров (руб.)
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_sum_close)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col w-64 my-auto gap-2 content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B] pr-5">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                    <p>Всего договоров</p>
                </div>
                <div className="flex flex-row w-fit my-auto content-center">
                    <div className="flex flex-col w-fit my-auto content-center pr-5">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Количество
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_count_perf)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col w-fit my-auto content-center">
                        <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                            Сумма договоров (руб.)
                        </div>
                        <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                            {loadingCountSum ? (
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            ) : contractCountAndSum ? (
                                fmt(contractCountAndSum.contracts_sum_perf)
                            ) : (
                                'Нет данных'
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="w-60 my-auto content-center ">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Закупки исключаемые у МСП
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">0,00 ₽</div>
            </div> */}
        </div>
    )
}

export default ContractHeader
